import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';

import AuthContext from '../context/auth-context';

import '../../node_modules/bootstrap/dist/js/bootstrap.bundle.min';
import classes from './Sidebar.module.css';


function Sidebar(props) {
    const authContext = useContext(AuthContext);
    const isLoggedIn = authContext.isLoggedIn;

    return (
            <aside className={`${classes.sidebar} ${props.toggleMenu && classes.isActive}`}>

                {/* OPCIONES MENU */}
                <nav className={classes.menu}>
                    <h2 style={{color: 'white', textAlign: 'center',fontStyle: 'italic'}}>UFM</h2>
                    <h6 style={{color: 'white', textAlign: 'center'}}>Posgrado</h6>
                    <br />
                    {!isLoggedIn && <NavLink className={(navData) => (navData.isActive ? `${classes.menuItem} ${classes.isActive}` : classes.menuItem)} to={"/login"}>Login</NavLink>}
                    {!isLoggedIn && <NavLink className={(navData) => (navData.isActive ? `${classes.menuItem} ${classes.isActive}` : classes.menuItem)} to={"/registro"}>Registro</NavLink>}
                    {isLoggedIn && <NavLink className={(navData) => (navData.isActive ? `${classes.menuItem} ${classes.isActive}` : classes.menuItem)} to={"/"}>Inicio</NavLink>}
                    {isLoggedIn && <NavLink className={(navData) => (navData.isActive ? `${classes.menuItem} ${classes.isActive}` : classes.menuItem)} to={"/informacion-aplicante"}>Información aplicante</NavLink>}
                    {/* {isLoggedIn && <NavLink className={(navData) => (navData.isActive ? `${classes.menuItem} ${classes.isActive}` : classes.menuItem)} to={"/pago"}>Pagar examen de admisión</NavLink>} */}
                    {/* {isLoggedIn && <NavLink className={(navData) => (navData.isActive ? `${classes.menuItem} ${classes.isActive}` : classes.menuItem)} to={"/programar-examen"}>Programar examen de admisión</NavLink>} */}
                    {/* {isLoggedIn && <NavLink className={(navData) => (navData.isActive ? `${classes.menuItem} ${classes.isActive}` : classes.menuItem)} to={"/instrucciones"}>Contáctenos</NavLink>} */}
                </nav>
                
            </aside>
        
    )
}

export default Sidebar;